'use strict';

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Declaration = require('../declaration');
var utils = require('./grid-utils');

var GridArea = function (_Declaration) {
    _inherits(GridArea, _Declaration);

    function GridArea() {
        _classCallCheck(this, GridArea);

        return _possibleConstructorReturn(this, _Declaration.apply(this, arguments));
    }

    /**
     * Translate grid-area to separate -ms- prefixed properties
     */
    GridArea.prototype.insert = function insert(decl, prefix, prefixes) {
        if (prefix !== '-ms-') return _Declaration.prototype.insert.call(this, decl, prefix, prefixes);

        var values = utils.parse(decl);

        var _utils$translate = utils.translate(values, 0, 2),
            rowStart = _utils$translate[0],
            rowSpan = _utils$translate[1];

        var _utils$translate2 = utils.translate(values, 1, 3),
            columnStart = _utils$translate2[0],
            columnSpan = _utils$translate2[1];

        [['grid-row', rowStart], ['grid-row-span', rowSpan], ['grid-column', columnStart], ['grid-column-span', columnSpan]].forEach(function (_ref) {
            var prop = _ref[0],
                value = _ref[1];

            utils.insertDecl(decl, prop, value);
        });

        return undefined;
    };

    return GridArea;
}(Declaration);

Object.defineProperty(GridArea, 'names', {
    enumerable: true,
    writable: true,
    value: ['grid-area']
});


module.exports = GridArea;


//////////////////
// WEBPACK FOOTER
// ./~/autoprefixer/lib/hacks/grid-area.js
// module id = 650
// module chunks = 0